import { Config } from '../../../../config/state/config-types'
import { FlowStep } from '../../flow-types'
import { INITIAL_INVALID_STEP_INDEX, INITIAL_NUM_VISITS } from './constants'

export const DONOR_STEP = 'donor'

export default function makeDonorStep(config: Config): FlowStep {
  const hasOptionalContactQuestions = config.questions.contact.some(
    (question) => !question.is_required,
  )

  const hasOptionalCustomQuestions = config.questions.custom.some(
    (question) => !question.is_required,
  )

  return {
    name: DONOR_STEP,
    title: 'Your information',
    enabled: hasOptionalContactQuestions || hasOptionalCustomQuestions,
    index: INITIAL_INVALID_STEP_INDEX,
    numVisits: INITIAL_NUM_VISITS,
    layout: 'one-column',
  }
}
